import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=641def8a&"
import script from "./providers.ts?vue&type=script&lang=ts&"
export * from "./providers.ts?vue&type=script&lang=ts&"
import style0 from "./providers.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports